import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app.settings';
import { hidePreloader } from 'src/app/helpers/hidePreloader';
import { NotandiService } from '../../services/api/notandi/notandi.service';

@Component({
  selector: 'app-page-container-simple',
  templateUrl: './page-container-simple.component.html',
  styleUrls: ['./page-container-simple.component.scss']
})
export class PageContainerSimpleComponent implements OnInit {
  public isBrowser: boolean;
  public isServer: boolean;

  constructor(public appSettings: AppSettings, public router: Router, @Inject(PLATFORM_ID) private platformId: Object, private notandiService: NotandiService, private changeDetectorRef: ChangeDetectorRef) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      hidePreloader();
    }

  }

}
